import { render, staticRenderFns } from "./candidate-bookings.vue?vue&type=template&id=0d0b5194&scoped=true&"
import script from "./candidate-bookings.vue?vue&type=script&lang=js&"
export * from "./candidate-bookings.vue?vue&type=script&lang=js&"
import style0 from "./candidate-bookings.vue?vue&type=style&index=0&id=0d0b5194&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0b5194",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VBadge,VCard})
